{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "Supprimer et retirer du projet | Supprimer et retirer des projets",
        "unsavedChanges": "Modifications non enregistrées!",
        "areYouSureYouWantToRemovePage": "Supprimer '{pageName}'.",
        "deleteStyle": "Supprimer le style?",
        "deleteMedia": "Supprimer le média?",
        "deleteMediaImplications": "Supprimer et retirer des projets ?",
        "deletePlayer": "Supprimer le player?",
        "deletePlayerImplications": "Cette action supprimera le player de votre compte ARYA et supprimera tous les paramètres liés à ce player, y compris ceux liés à la programmation.",
        "permanentlyDeleteTheUserAccount": "Supprimer le compte.",
        "removeTemplate": "Retirer le modèle",
        "removeTemplateDesc": "Voulez-vous retirer ce modèle de ce style ?",
        "removeTheMediaFromTheSchedule": "Supprimer du planning.",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Supprimer le média.",
        "mediaUsedInProject": "Média utilisé dans le projet | Média utilisé dans les projets",
        "confirmPassword": "Confirmer le mot de passe",
        "changeEmail": "Changer l’adresse e-mail",
        "deleteOrder": "Supprimer la commande",
        "deleteTag": "Supprimer le tag ?",
        "deletePopId": "Supprimer l'ID PoP ?",
        "deleteUser": "Supprimer l'utilisateur ?",
        "deleteAccount": "Supprimer le compte ?",
        "leaveAccount": "Quitter le compte ?",
        "deleteCanvasResolution": "Supprimer la résolution du canvas ?",
        "downloadLicense": "Télécharger la licence ?",
        "cancelOrder": "Annuler la commande ?",
        "removeAccessFromArya": "Supprimer l'accès d'ARYA ?",
        "deleteTemplate": "Supprimer le modèle ?"
    },
    "signinup": {
        "new": "Nouveau chez {productNameShort}?",
        "newUser": "Nouvel utilisateur"
    },
    "label": {
        "aryaAccountID": "ID de compte Arya",
        "accountId": "ID de compte",
        "admin": "admin",
        "addPlayer": "Ajouter un Player",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "Le code {code} a déjà été attribué dans un autre compte.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "Le code {code} a déjà été attribué.",
        "account": "Compte | Comptes",
        "accountInfo": "Informations du compte",
        "accountInformation": "Informations du compte",
        "accountName": "Nom de compte",
        "accountPlan": "Plan de compte",
        "accountCorrespondent": "Correspondant de compte",
        "accountIsDeleted": "Le compte a été supprimé",
        "activate": "Activer",
        "address": "adresse",
        "alert": "alerte | alertes",
        "amount": "montant",
        "apply": "Appliquer",
        "assign": "assigner | assigner",
        "audio": "audio",
        "auto": "auto",
        "basic": "basique",
        "bannerText1": "Maintenance programmée",
        "bannerText2": "Nous effectuerons une maintenance programmée le {date} à {time} pendant environ {approximateHours} heures. Nous nous excusons pour tout désagrément causé pendant cette période.",
        "bannerText3": "Pendant la maintenance, il ne sera pas possible de modifier le contenu de {productName}, mais les players continueront à afficher leur contenu.",
        "billing": "facturation",
        "billingDetails": "Détails de la facturation",
        "buy": "acheter",
        "comment": "commenter",
        "companyInformation": "Informations sur l’entreprise",
        "contentNotSupported": "contenu non pris en charge, cliquer pour plus d'informations...",
        "copy": "copie | copies",
        "configPending": "Configuration en cours",
        "configError": "Erreur de configuration",
        "credentials": "identifiants",
        "credentialsNotValid": "Identifiants non valides",
        "createStyle": "créer un style",
        "createUserExistErrorMessage": "{email} est déjà membre de ce compte.",
        "createUserLimitReached": "Limite d'utilisateurs atteinte",
        "creditCard": "Carte de crédit",
        "download": "Télécharger",
        "extended": "étendu",
        "expirationDate": "Date d'expiration",
        "expires": "expire",
        "language": "Langue",
        "learnMore": "en savoir plus",
        "leaveAccount": "Quitter le compte",
        "leaveAccountWithOnlyOneUserMessage": "Vous ne pouvez pas quitter le compte car vous en êtes le seul utilisateur.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "Vous ne pouvez pas quitter le compte car vous en êtes le seul utilisateur.",
        "leaveAccountImplicationsCommonMessage": "Cette action vous retirera de ce compte.",
        "license": "licence",
        "limited": "limité",
        "location": "Emplacement",
        "login": "Connexion",
        "loginError": "Une erreur s'est produite, nous ne pouvons pas vous connecter pour le moment. Veuillez réessayer plus tard ou contacter votre administrateur.",
        "loginWith": "Se connecter avec",
        "loginString2": "Contenu affiché à l'écran en une fois. Gratuit.",
        "loginString3": "La simplicité au service de l'affichage numérique.",
        "loginString4": "Commandez et activez des ensembles de fonctionnalités en toute simplicité",
        "loginOKStringTitle2": "La simplicité au service de Smart Sync.",
        "loginOKStringDesc1": "Personnalisez-le. Planifiez-le. Priorisez-le.",
        "loginOKStringDesc2": "Taguez-le. Faites le Smart Sync. Alertez si nécessaire.",
        "loginOKString4": "Étape suivante. Configuration rapide du player.",
        "loginOKString5": "Tout ce dont vous avez besoin est le numéro de série de votre player.",
        "loginOKQuotaWarnMain": "Stockage gratuit {percentage}% utilisé.",
        "loginOKQuotaWarnSub": "Passez au {plan} pour accéder à des modèles et alertes entièrement personnalisables, 10 Go de stockage par lecteur, 10 utilisateurs, des tags et la synchronisation des tags intelligents, et bien plus encore.",
        "loginOKQuotaReachedMain": "Stockage gratuit {percentage}% utilisé.",
        "loginOKQuotaReachedSub": "Passez au {plan} pour accéder à des modèles et alertes entièrement personnalisables, 10 Go de stockage par lecteur, 10 utilisateurs, des tags et la synchronisation des tags intelligents, et bien plus encore.",
        "loginOKQuotaExcededMain": "Stockage gratuit plein.",
        "loginOKQuotaExcededSub": "Passez au {plan} pour accéder à des modèles et alertes entièrement personnalisables, 10 Go de stockage par lecteur, 10 utilisateurs, des tags et la synchronisation des tags intelligents, et bien plus encore.",
        "logoutOKStringTitle1": "VOUS ÊTES MAINTENANT DÉCONNECTÉ",
        "logoutOKStringDesc1": "Vous pouvez vous reconnecter en cliquant sur le bouton ci-dessous.",
        "notice": "avis",
        "playerSetupString1": "Créez votre projet.",
        "playerSetupString2": "C'est super facile. C'est super rapide.",
        "playerSetupString3": "",
        "payments": "paiements",
        "pageNotFound": "Désolé, page introuvable",
        "plan": "plan | plans",
        "popIdentifier": "IDENTIFIANT PoP",
        "postalCode": "Code postal",
        "purchasePlanUpgradeSuccessMain": "Bienvenue dans {plan}",
        "purchasePlanDowngradeSuccessMain": "Le compte a été rétrogradé vers {planName}",
        "loggedOffInFewSeconds": "Vous serez déconnecté dans quelques secondes",
        "termsOfServiceString1": "Conditions d'utilisation",
        "termsOfServiceString2": "Dernière mise à jour : 9 janvier 2019",
        "termsOfServiceString3": "Veuillez télécharger et lire le document suivant",
        "termsOfServiceString4": "CONDITIONS D'UTILISATION",
        "termsOfServiceString5": "POLITIQUE DE CONFIDENTIALITÉ",
        "termsOfServiceString6": "Sélectionnez ACCEPTER pour continuer.",
        "accept": "Accepter",
        "all": "Tout",
        "allPlayers": "Tous les players",
        "add": "Ajouter",
        "setPassword": "Confirmer",
        "support": "support",
        "cancel": "annuler",
        "canvasSize": "Taille du canvas : {size} pixels",
        "canvasExistsError": "Un canvas de cette taille existe déjà",
        "cardType": "type de carte",
        "cardNumber": "numéro de carte",
        "change": "changer",
        "clickToEdit": "cliquer pour éditer",
        "city": "ville",
        "color": "couleur | couleurs",
        "company": "entreprise",
        "companyName": "Nom de l'entreprise",
        "confirm": "Confirmer",
        "confirmation": "Confirmation",
        "warning": "Avertissement",
        "codeIsRequired": "Code de vérification requis",
        "code": "Code",
        "contact": "contact",
        "country": "pays",
        "create": "Créer",
        "checkThePlayer": "Connectez-vous à Internet. Branchez l'alimentation.",
        "checkDetails": "Vérifiez les détails",
        "chooseHorizontalOrVerticalScreenOrientations": "Choisissez l'orientation de l'écran",
        "continue": "Continuer",
        "conctactSystemAdmin": "Veuillez contacter votre administrateur système.",
        "custom": "personnalisé",
        "customerInfo": "Informations client",
        "date": "date",
        "deactivate": "désactiver",
        "default": "défaut",
        "dropFilesHere": "Déposez les fichiers ici",
        "delete": "supprimer",
        "deleteAccount": "supprimer le compte",
        "deleteAccountWithMultipleUsersMessage": "Vous devez supprimer tous les autres utilisateurs avant de pouvoir supprimer ce compte.",
        "deleteAccountWithDistributorRightsMessage": "Ce compte ne peut pas être supprimé. Il appartient à un distributeur.",
        "deleteAccountTitleThisActionWill": "Cette action va",
        "deleteAccountImplications": {
            "deleteAccount": "1. supprimer le compte",
            "deleteUser": "2. Supprimer l'utilisateur"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "Vous ne pouvez pas supprimer un utilisateur car vous en êtes le seul utilisateur.",
        "deleteUser": "supprimer l’utilisateur",
        "deleteOnAllPlayers": "SUPPRIMER sur TOUS LES PLAYERS.",
        "deleteFromSchedule": "Supprimer du programme",
        "demoVersion": "Version démo",
        "disable": "désactiver",
        "disabled": "désactivé",
        "distributor": "distributeur",
        "downgradeAccount": "Rétrograder le compte",
        "downgradeTo": "Rétrogradation à {plan}",
        "duplicate": "Dupliquer",
        "duplicateFile": "Fichier dupliqué",
        "duplicateInSchedule": "Dupliquer dans le programme",
        "duration": "Durée",
        "adsDuration": "Durée des pubs",
        "error": "erreur",
        "email": "e-mail",
        "emailAlreadyExists": "La nouvelle adresse électronique est déjà utilisée par un autre utilisateur, veuillez en utiliser une autre.",
        "enable": "activer",
        "enabled": "activé",
        "endDate": "Fin",
        "endTime": "Fin",
        "end": "fin",
        "edit": "Modifier",
        "editProject": "Modifier le projet",
        "feedbackForm": "Donner un avis",
        "firstName": "Prénom",
        "firmwareUpdate": "MISE À JOUR",
        "failed": "Contacter l’assistance",
        "file": "Fichier | Fichiers",
        "forgotPassword": "Mot de passe oublié",
        "formatNotSupported": "Les fichiers '{format}' ne sont pas supportés.",
        "firmware": "Firmware",
        "freeVersion": "Version gratuite",
        "freeVersionNA": "N/A Version Gratuite",
        "get": "obtenir",
        "getCode": "Obtenir la configuration",
        "getConfig": "Obtenir la configuration",
        "generateNewAPIKey": "Générer une nouvelle clé API",
        "generateUserAPIKeyWarningMessage": "Cette action rendra la précédente clé API invalide. Toute connexion existante à l'API devra être reconfigurée pour utiliser la nouvelle clé API.",
        "goBack": "Retour",
        "goToLogin": "Aller à la connexion",
        "helpCenter": "Centre d'aide",
        "horizontalView": "Vue horizontale",
        "image": "Image | Images",
        "implications": "conséquences",
        "implicationsDeleteTag": "Cette action supprimera le tag de tous les {deleteFrom}. Cela pourrait affecter vos autorisations d'utilisateur et votre programme.",
        "implicationsDeleteLedTag": "Cette action supprimera le tag de tous les players. Tout player ayant ce tag devra être reconfiguré pour que du contenu avec cette résolution puisse y être publié à nouveau.",
        "implicationsDeletePopId": "Cette action supprimera cet ID PoP partout où il est utilisé.",
        "importantToNote": "Important à noter",
        "logo": "logo",
        "userProfile": "Profil de l'utilisateur",
        "userSignOut": "Se déconnecter",
        "userNotConfirmed": "Utilisateur non confirmé",
        "userNotFound": "L'utilisateur n'existe pas. Veuillez vérifier que ce compte existe",
        "userManagement": "Gestion des utilisateurs",
        "id": "id",
        "incorrectUsername": "Adresse e-mail incorrecte",
        "incorrectPassword": "Mot de passe incorrect",
        "installed": "Installé",
        "installedOrCapacity": "Installé/Capacité",
        "installedOrCapacityUnlimitedMaxValue": "de players illimités",
        "invalidEmail": "Adresse e-mail invalide",
        "invalidPassword": "Mot de passe incorrect",
        "invalidUserdata": "Contacter l’assistance",
        "invalidSerialNumber": "Numéro de série incorrect",
        "invalidDSOSTypeAmount": "Valeur invalide, veuillez saisir un nombre.",
        "invalidResolution": "Résolution non valide",
        "invoice": "facture | factures",
        "inviteUser": "Inviter un utilisateur",
        "keyboardShortcuts": "Raccourcis clavier",
        "requiredDeviceName": "Nom requis",
        "regular": "ordinaire",
        "resetPassword": "Réinitialiser le mot de passe",
        "loading": "Chargement...",
        "lastName": "Nom",
        "lastLogin": "Dernière connexion",
        "modify": "modifier",
        "monitoring": "monitoring",
        "newPassword": "Nouveau mot de passe",
        "newPasswordRequiredWarning": "Vous devez changer votre mot de passe avant de continuer",
        "confirmNewPassword": "Confirmez le nouveau mot de passe",
        "new": "Nouveau",
        "newCanvas": "Nouveau canvas",
        "newProject": "nouveau projet",
        "newEmail": "Nouvelle adresse e-mail",
        "newResolution": "Nouvelle résolution",
        "name": "Nom",
        "naText": "N/A",
        "next": "suivant",
        "nextRenewalDate": "Prochain renouvellement {renewalDate}",
        "noVideoAvailable": "Aucune vidéo disponible.",
        "noEmailProvided": "Aucune adresse e-mail fournie",
        "none": "aucun",
        "noSearchResults": "aucun résultat",
        "noPermissionToAccessThePage": "Accès refusé",
        "noPlayersInstalled": "Aucun player installé",
        "noPlayerGroupsAvailable": "Aucun groupe de players disponible",
        "notConfigured": "Configuration requise",
        "nameYourPlayerEGReception": "Nommez votre player. Par exemple : Accueil",
        "ok": "OK",
        "or": "ou",
        "order": "commande | commandes",
        "orders": "commandes",
        "offline": "Hors ligne",
        "online": "en ligne",
        "options": "options",
        "page": "Page",
        "player": "player | players",
        "playerName": "Nom du lecteur",
        "playerModel": "Modèle du lecteur",
        "playerGroups": "Groupe de players",
        "pleaseEnterACity": "Entrez la ville",
        "pin": "Code PIN",
        "pinShownOnYourScreen": "Code PIN affiché sur votre écran",
        "playTime": "Durée de lecture",
        "PleaseTryAgainOrHeadBackToTheHomepage": "Veuillez réessayer ou retourner à la page d'accueil.",
        "playerIsNotConnectedToTheCloud": "Numéro de série incorrect",
        "pleaseTryAgain": "Réessayer",
        "pleaseEnterThePin": "Code PIN requis",
        "pleaseEnterValidPin": "Saisir le numéro à 4 ou 6 chiffres affiché à l'écran",
        "pinMustBeFourDigitNumber": "Le code PIN doit être composé de 4 à 6 chiffres",
        "pinMustBeAtleastOneThousand": "Le code PIN doit être d'au moins 1000",
        "pleaseCheckYourEmailForVerificationCode": "Un code de vérification a été envoyé à votre adresse e-mail",
        "password": "mot de passe",
        "passwordDidNotMatch": "Le mot de passe ne correspond pas",
        "passwordCannotBeReset": "Le mot de passe ne peut pas être réinitialisé",
        "passwordHasBeenChanged": "Votre mot de passe a été modifié",
        "passwordAttemptLimitExceeded": "La limite d'essai est atteinte, veuillez réessayer dans quelques minutes.",
        "passwordPolicyRequirementText": "Le mot de passe doit comporter au moins 8 caractères, avec des majuscules, des minuscules, des chiffres et des caractères spéciaux.",
        "price": "Prix",
        "priceSlashMonth": "Prix/Mois",
        "priority": "priorité",
        "project": "Projet | Projets",
        "projectName": "Nom du projet",
        "profile": "Profil",
        "proofOfPlay": "Preuve de lecture",
        "preview": "Aperçu",
        "previewUnavailable": "Aperçu non disponible",
        "privacy": "Confidentialité",
        "proceed": "procéder ",
        "publishTo": "publier sur",
        "releaseNotes": "Notes de version",
        "remove": "supprimer",
        "removeUserFromAccount": "supprimer l’utilisateur du compte",
        "replace": "remplacer",
        "reporting": "reporting",
        "reset": "réinitialiser",
        "restart": "redémarrer",
        "resolution": "résolution",
        "reactivate": "réactiver",
        "resetPasswordDescription": "Entrez une adresse e-mail pour recevoir le code de vérification",
        "resetPasswordCodeSent": "Un code de vérification a été envoyé à votre adresse e-mail",
        "resetPasswordCodeSentIfAccountExist": "SI LE COMPTE EXISTE",
        "requiredAccountName": "Nom du compte requis",
        "requiredEmail": "Email requis",
        "requiredCountry": "Pays requis",
        "requiredPassword": "Mot de passe requis",
        "requiredConfirmPassword": "Confirmation du mot de passe requis",
        "requiredFirstName": "Prénom requis",
        "requiredLastName": "Nom requis",
        "requiredName": "Nom requis",
        "requiredUsername": "E-mail requis",
        "requiredVerificationCode": "Code de vérification requis",
        "requiredSerialNumber": "Numéro de série requis",
        "requiredCity": "Ville requise",
        "requiredState": "État requis",
        "requiredZipOrPostalCode": "Code postal requis",
        "requiredStreetAndNumber": "Rue et numéro requis",
        "requiredCompanyName": "Nom de l'entreprise requis",
        "requiredDataStorageRegion": "Région de stockage des données requise",
        "invalidDataStorageRegion": "Région de stockage des données invalide",
        "review": "vérification",
        "search": "Recherche",
        "addressSearchPlaceholder": "Entrer l'adresse pour localiser les players",
        "searching": "recherche",
        "signOut": "se déconnecter",
        "status": "statut",
        "save": "enregistrer",
        "reconfigure": "Redémarrer la configuration",
        "saveAs": "Enregistrer sous",
        "saveChanges": "Enregistrer les modifications",
        "savedStyles": "styles sauvegardés",
        "schedule": "programme",
        "scheduledToTag": "Programmé pour le tag",
        "screen": "écran",
        "screenOn": "Écran allumé",
        "screenOrientation": "Orientation de l'écran",
        "security": "Sécurité",
        "sendCode": "Envoyer le code",
        "sendEmail": "Envoyer",
        "sendInvitation": "Envoyer l'invitation",
        "sendTo": "Envoyer à",
        "serial": "Numéro de série",
        "serialNumber": "Numéro de série",
        "serialNumberAlreadyAssigned": "Numéro de série déjà attribué",
        "select": "SÉLECTIONNER",
        "selectAll": "tout sélectionner",
        "selectLanguage": "choisir la langue",
        "setup": "Configuration",
        "settings": "paramètres",
        "shapeColors": "Couleurs de la forme",
        "shareWithText": "{productShortName} Affichage numérique. Simple. Intelligent. Puissant.",
        "signIn": "Connexion",
        "signUp": "Inscription",
        "signUpErrorMessageAccountEmailExist": "Un compte avec l'adresse e-mail indiquée existe déjà.",
        "slowSync": "SYNCHRO LENTE ",
        "sorry": "Désolé.",
        "streetAndNumber": "Rue et numéro",
        "success": "Succès",
        "summary": "résumé",
        "somethingWentWrong": "Une erreur s’est produite",
        "song": "chanson | Chansons",
        "startDate": "Date de début",
        "startTime": "Début",
        "start": "Début",
        "state": "état",
        "steps": "étapes",
        "styleName": "Nom du style",
        "storage": "stockage",
        "subtotal": "total",
        "subscription": "abonnement",
        "subscriptionMonthlyAutoRenew": "Mensuel (renouvellement automatique)",
        "ssoLoginErrorTitle": "Une erreur s'est produite, nous ne pouvons pas vous connecter pour le moment. Veuillez réessayer plus tard ou contacter votre administrateur.",
        "ssoMigrateAccountStep1Title1": "Un compte avec l’adresse {email} existe déjà.",
        "ssoMigrateAccountStep1Title2": "Vous pouvez le changer pour utiliser l'authentification SSO {provider}.",
        "ssoMigrateAccountStep1Title3": "Continuez pour confirmer le changement.",
        "ssoMigrateAccountStep2Title1": "Une fois que vous avez confirmé le passage à {provider} SSO,",
        "ssoMigrateAccountStep2Title2": "votre connexion précédente ne fonctionnera plus.",
        "ssoMigrateAccountStep2Title3": "Cette action ne peut pas être annulée.",
        "ssoMigrateAccountVerifyTitle1": "Nous devons vérifier votre compte {email} existant.",
        "ssoMigrateAccountVerifyTitle2": "Veuillez vous connecter avec ce compte pour continuer.",
        "tag": "tag | tags",
        "defaultTags": "Tags par défaut",
        "text": "texte",
        "timeZone": "Fuseau horaire",
        "time": "heure",
        "timeShorthandSecond": "SEC",
        "timeShorthandMinute": "MIN",
        "timeShorthandHour": "H",
        "template": "Modèle | Modèles",
        "temporaryPassword": "mot de passe temporaire",
        "tempPasswordExpiredPleaseContactAdmin": "Le mot de passe temporaire a expiré. Veuillez contacter votre administrateur",
        "total": "total",
        "tutorial": "Tutoriel | Tutoriels",
        "user": "utilisateur",
        "userAPIKey": "Clé API",
        "userNotActive": "Utilisateur non actif",
        "usernameShouldBeValidEmail": "Le nom d'utilisateur doit être une adresse e-mail valide",
        "updatedAccountInfo": "Les informations relatives à votre compte ont été mises à jour.",
        "updatedCustomerInfo": "Vos informations client ont été mises à jour.",
        "updatedProfile": "Votre profil d'utilisateur a été mis à jour.",
        "updated": "mis à jour",
        "upload": "Télécharger",
        "upgrade": "mise à niveau",
        "upTime": "fonctionnement",
        "video": "Vidéo",
        "vat": "TVA",
        "verificationCode": "Code de vérification",
        "verticalView": "Vue verticale",
        "withResolution": "avec une résolution de {resolution}",
        "yourPlan": "votre plan",
        "youHaveLeftAccount": "Vous avez quitté le compte",
        "zipOrPostalCode": "Code postal",
        "mon": "Lun.",
        "tue": "Mar.",
        "wed": "Mer.",
        "thu": "Jeu.",
        "fri": "Ven.",
        "sat": "Sam.",
        "sun": "Dim.",
        "apps": "applications",
        "multiplePopIdsNotAllowed": "Chaque fichier ne peut contenir qu'un seul identifiant de preuve de lecture.",
        "forbidden": "Une erreur s'est produite et nous n'avons pas pu traiter votre demande. Vous allez être redirigé vers la page d'accueil dans un instant.",
        "dataStorageRegion": "Région de stockage des données",
        "verificationSentToEmailIfExist": "Code de vérification envoyé à votre e-mail (si le compte existe)",
        "alreadyHaveAnAccountRedirect": "Vous avez déjà un compte ? {linkStart}Connexion{linkEnd}",
        "emailText": "E-mail",
        "passwordText": "Mot de passe",
        "signupWith": "S'inscrire avec",
        "setNewPassword": "Définir le mot de passe",
        "passwordHint": "{minStart}Minimum 8 caractères,{minEnd} {upStart}majuscule,{upEnd} {lowStart}minuscule,{lowEnd} {numStart}chiffre{numEnd}{numSpecialSeparatorStart} et {numSpecialSeparatorEnd}{spStart}caractère spécial{spEnd}.",
        "home": "Accueil",
        "loginWithName": "Se connecter avec {name}",
        "signupWithName": "S'inscrire avec {name}",
        "fileType": "Type de fichier",
        "lastModified": "Dernière modification",
        "images": "Images",
        "videos": "Vidéos",
        "projectsOrPdf": "Projets / PDF",
        "elementiProject": "Projets Elementi",
        "scheduled": "Planifié",
        "notScheduled": "Non planifié",
        "from": "Du",
        "to": "Au",
        "fileTypes": "Types de fichiers",
        "contentStatus": "Statut du contenu",
        "modifiedDate": "Date de modification",
        "filters": "Filtres",
        "sortBy": "Trier par",
        "sort": "Trier",
        "lastModifiedDesc": "Dernière modification (plus récent en premier)",
        "lastModifiedAsc": "Dernière modification (plus ancien en premier)",
        "nameAsc": "Nom (A → Z)",
        "nameDesc": "Nom (Z → A)",
        "grid": "Grille",
        "canvas": "Canevas",
        "audioPlaylist": "Liste de lecture audio",
        "isAlertActive": "Alert actif",
        "active": "Actif",
        "inactive": "Inactif",
        "filesPage": "Page Fichiers",
        "ledPage": "Page LED",
        "videowallPage": "Page Videowall",
        "alertPage": "Page Alertes"
    },
    "buttons": {
        "backToProduct": "Retour à {productName}",
        "reload": "Recharger",
        "previous": "Précédent",
        "next": "Suivant",
        "loadMore": "Charger plus",
        "addNewUser": "Ajouter un nouvel utilisateur",
        "apply": "Appliquer",
        "clearAll": "Tout effacer",
        "reset": "Réinitialiser",
        "tryItNow": "Essayez maintenant",
        "switchBack": "Revenir à l'ancien",
        "cancel": "Annuler",
        "deleteMedia": "Supprimer le média",
        "deletePlayer": "Supprimer le lecteur",
        "deleteTag": "Supprimer le tag",
        "deletePopId": "Supprimer l'ID PoP",
        "deleteUser": "Supprimer l'utilisateur",
        "continueWithoutSaving": "Continuer sans enregistrer",
        "close": "Fermer",
        "cancelOrder": "Annuler la commande",
        "removeUser": "Supprimer l'utilisateur",
        "deleteTemplate": "Supprimer le modèle",
        "deleteStyle": "Supprimer le style",
        "ok": "OK",
        "delete": "Supprimer",
        "keepBoth": "Conserver les deux",
        "replaceExistingFile": "Remplacer le fichier existant",
        "replaceExistingFiles": "Remplacer les fichiers existants"
    },
    "texts": {
        "youAreLoggingIn": "Vous êtes connecté avec",
        "productAccessDisabled": "Vous n'avez pas accès à {product}",
        "productAccessDisabledWarning": "Vous n'avez pas accès à {product} pour le compte {account}.\n\nSoit l'accès à ce produit ne vous a pas été accordé, soit votre accès a été révoqué par l'Administrateur Global. Veuillez contacter l'Administrateur Global pour plus d'informations ou pour demander l'accès.\n\nVous pouvez continuer à accéder à d'autres produits que vous êtes autorisé à utiliser dans ce compte.",
        "tablePageCountWTotal": "Affichage de {min}{separator}{max} sur {total}",
        "tablePageCountWoutTotal": "Affichage de {min}{separator}{max}",
        "dataStorageRegionHint": "Choisissez la région où vos données de compte seront stockées. Cette décision doit être alignée avec vos lois locales de protection des données et vos besoins de conformité. Veuillez noter : une fois sélectionnée, la région de résidence des données ne peut plus être modifiée ultérieurement.",
        "welcomeToHUB": "Bienvenue sur SpinetiX HUB !",
        "welcomeToHUBDesc": "SpinetiX HUB est votre plateforme en ligne tout-en-un pour gérer tout ce qui concerne votre affichage numérique SpinetiX dans le cloud.",
        "hubGlobalAdmin": "Administrateur Global SpinetiX",
        "hubGlobalAdminDesc": "Cet utilisateur est un Administrateur Global sur le HUB, ce qui lui accorde automatiquement le rôle d'Administrateur dans ARYA. Cette attribution de rôle ne peut pas être modifiée.",
        "removeAccessFromAryaTitle": "Supprimer l’accès à ARYA ?",
        "removeAccessFromAryaMessage": "Cela supprimera uniquement l'accès de {userName} à ARYA.",
        "removeAccessFromAryaByNonGlobalAdmin": "Pour supprimer l’utilisateur du compte HUB, veuillez contacter votre Global Admin.",
        "removeAccessFromAryaByGlobalAdmin": "Ils/elles conserveront l'accès aux autres produits de ce compte HUB.\n\nPour supprimer l'utilisateur du compte HUB, veuillez aller à {link}",
        "hubUserManagement": "Gestion des utilisateurs HUB",
        "goToHUBUserManagement": "veuillez accéder à la gestion des utilisateurs de HUB.",
        "noContentHasBeenScheduledYet": "Aucun contenu n'a encore été planifié.",
        "emptyFilterTablePlaceholder": "Nous n'avons trouvé aucun élément correspondant à votre recherche. Essayez d'ajuster vos termes de recherche et réessayez !",
        "requestId": "ID de demande :",
        "externalSignInMessage": "Vous êtes connecté avec un fournisseur d'identité externe (ex. : Google, Facebook ou SSO avec un autre fournisseur d'identité). Vos informations d'identification, y compris {email} et {password}, sont gérées par ce fournisseur.",
        "youHaveUnsavedChanges": "Vous avez des modifications non enregistrées.",
        "waitForUploadingFile": "Téléchargement du fichier en cours, veuillez patienter...",
        "defaultTagsNote": "Les projets héritent des tags du Style Pack lorsqu'ils sont créés à partir du modèle. Si vous ajoutez ou supprimez des tags du Style Pack ultérieurement, les projets existants ne seront pas mis à jour.",
        "seeAll": "Voir tout",
        "allPlayTimes": "Tous les horaires de diffusion"
    },
    "unsupportedBrowser": {
        "bannerTitle": "Votre navigateur n'est pas pris en charge",
        "bannerMessage": "Vous utilisez un navigateur qui n'est pas pris en charge. Certaines fonctionnalités risquent de ne pas fonctionner correctement. Pour une expérience optimale, nous vous recommandons d’utiliser {highlightStart}Google Chrome{highlightEnd} ou {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "switchedAccount": {
        "title": "Compte basculé",
        "desc1": "Bon retour.",
        "switch": "changer",
        "text1": "Compte basculé",
        "text2": "vers {account}"
    },
    "plans": {
        "downgradedToFreeDesc": "Le plan {plan} est maintenant activé. Votre carte sera débitée une dernière fois à la fin du cycle de facturation.",
        "free": "Gratuit",
        "tags": "SMART SYNC & TAGS",
        "sharedStorage": "stockage partagé",
        "custom": "Personnalisation & Alertes",
        "playerStorage": "Stockage du player",
        "playerPerMonth": "player/mois | players/mois",
        "review": {
            "termsAndConditionsMain": "En passant votre commande, vous acceptez",
            "termsAndConditionsSub": "les conditions générales de vente de SpinetiX"
        }
    },
    "filters": {
        "images": "images",
        "videos": "vidéos",
        "audio": "audio",
        "projectsOrPdf": "projets/PDF",
        "scheduled": "programmé",
        "elementiProject": "projets elementi"
    },
    "template": {
        "24H": "24 H",
        "AM/PM": "matin/soir",
        "addPage": "Ajouter une page",
        "arrowSettings": "Paramètres de la flèche",
        "back": "Retour",
        "background": "Arrière-plan",
        "both": "Les deux",
        "bottom": "fond",
        "center": "centre",
        "cellSettings": "Paramètres des cellules",
        "clock": "horloge",
        "clockSettings": "Paramètres de l'horloge",
        "countdown": "compte à rebours",
        "countdownSettings": "Paramètres du compte à rebours",
        "custom": "personnalisé",
        "changeMedia": "Changer de média",
        "default": "défaut",
        "duplicatePage": "Page dupliquée",
        "date": "date",
        "days": "jours",
        "effects": "Effets",
        "fade": "Fondu",
        "fill": "remplir",
        "front": "Avant",
        "frameFitting": "Ajustement du cadre",
        "hours": "heures",
        "imageEffects": "Effets d'image",
        "kenBurns": "Ken Burns",
        "noEffect": "Pas d’effet",
        "noBorder": "Pas de bordure",
        "noMargin": "Pas de marge",
        "L": "L",
        "large": "large",
        "left": "Gauche",
        "local": "local",
        "long": "long",
        "M": "M",
        "meet": "rencontre",
        "media": "média",
        "menu": "menu",
        "mediatable": "table des médias",
        "middle": "Moyen",
        "month": "mois",
        "overlay": "superposition",
        "overview": "vue d'ensemble",
        "playOnce": "Jouer une fois",
        "qr": "qr",
        "reg": "reg",
        "repeat": "répéter",
        "right": "Droit",
        "rss": "RSS",
        "shape": "forme",
        "shapeSettings": "Paramètres de forme",
        "shapeSettingsHint": "Astuce : Commencez à taper pour ajouter du texte",
        "slice": "tranche",
        "slide": "Diapositive",
        "small": "petit",
        "smart": "intelligent",
        "S": "S",
        "time": "Heure",
        "timeAndDate": "HEURE + DATE",
        "tableSettings": "Paramètres du tableau",
        "text": "texte",
        "textSettings": "Paramètres du texte",
        "top": "haut",
        "wayfinding": "orientation",
        "weather": "météo",
        "html": "page web",
        "url": "url",
        "videoin": "Vidéo-In",
        "videoWidth": "largeur de la vidéo",
        "videoHeight": "hauteur de la vidéo",
        "videoSettings": "Paramètres de la vidéo",
        "frameRate": "fréquence d'images",
        "frameWidth": "Sélectionner la largeur",
        "format": "format",
        "error": {
            "invalidLink": "Lien invalide"
        },
        "placeholder": {
            "url": "Entrer l'URL"
        },
        "weatherIconSettings": "Paramètres de l'icône météo",
        "weatherLocationSettings": "Paramètres de localisation météo",
        "weatherLocationSettingsHint": "Astuce : Entrez le nom du lieu",
        "webpageSettings": "Paramètres de la page web",
        "qrSettings": "Paramètres QR",
        "rssSettings": "Paramètres RSS",
        "rssSettingsTooltip": "Les flux RSS proposés par {productName} proviennent de <b>fournisseurs tiers</b>.<br>Nous nous efforçons d'offrir une sélection variée de flux pour répondre à vos besoins. Toutefois, leur qualité et leur performance dépendent entièrement des fournisseurs tiers.",
        "stream": "Stream",
        "list": "Liste"
    },
    "templates": {
        "duration": "Durée",
        "pageDuration": "Durée de la page",
        "timezone": "Fuseau horaire",
        "tags": "Tags",
        "playtimes": "Durée de lecture",
        "alignElements": "Aligner les Éléments",
        "removeTemplateConfirmation": "Êtes-vous sûr de vouloir supprimer ce modèle du style \"{styleName}\" ?",
        "deleteStyleConfirmation": "Êtes-vous sûr de vouloir supprimer le style \"{styleName}\" ?",
        "deleteStyleWarning": "En supprimant ce style, vous supprimerez tous les modèles créés dans celui-ci.",
        "noTemplatesAvailable": "Aucun modèle disponible",
        "noStylePackAccess": "Vous n'avez actuellement accès à aucun pack de styles contenant des modèles. Les packs de styles ne sont disponibles que lorsqu'ils sont partagés avec vous via vos autorisations ou tags attribués.\nSi vous pensez que vous devriez y avoir accès, veuillez contacter votre administrateur de compte."
    },
    "Hours": {
        "title": "Titre",
        "time": "Heures",
        "media": "Média"
    },
    "Info": {
        "info": "Info",
        "title": "Titre",
        "description": "Texte",
        "media": "Média"
    },
    "Logo": {
        "title": "Texte"
    },
    "Menu": {
        "menu": "Menu",
        "title": "Texte",
        "price": "Prix",
        "media": "Média"
    },
    "News": {
        "news": "Actualités",
        "title": "Texte",
        "timezone": "Fuseau horaire",
        "format": "Format",
        "media": "Média"
    },
    "Person": {
        "person": "Personne",
        "title": "Texte en haut",
        "description": "Texte en bas",
        "media": "Média"
    },
    "Product": {
        "product": "Produit",
        "title": "Texte",
        "price": "Prix",
        "media": "Média"
    },
    "RSS": {
        "rss-news": "Actualités RSS",
        "rss": "RSS",
        "news": "Nouvelles"
    },
    "Weather": {
        "weather": "Météo",
        "locations": "Ville",
        "media": "Média",
        "display": "Affichage"
    },
    "playerSetup": {
        "navConfirm": "Confirmer",
        "navFinish": "Terminer",
        "navNext": "Suivant",
        "navPrev": "Retour",
        "navCancel": "Annuler",
        "addPlayerToPlan": "Ajouter un player à votre programme",
        "currentPlan": "Programme actuel",
        "canvasName": "Nom du canvas",
        "canvasVideoNote": "Vous trouverez votre nouveau canvas dans le {canvasType} sous ce nom.",
        "canvasVideoNoteType_led": "Section LED",
        "canvasVideoNoteType_videowall": "Section Video Wall",
        "canvasSize": "Taille du canvas",
        "canvasSizeFormatted": "{canvasSize} pixels",
        "updateTo": "Mettre à jour vers",
        "numberOfPlayers": "Nombre de players",
        "dialogTitle": "Configuration du player",
        "onlyDigitsRequired": "Veuillez saisir des chiffres uniquement",
        "serialNumberRequired": "Le numéro de série ne peut pas être vide",
        "incorrectSerialNumber": "Veuillez saisir un numéro de série correct",
        "incorrectSerialNumberCharacters": "Veuillez saisir une entrée valide. Vous ne pouvez utiliser que des lettres et des chiffres anglais dans ce champ",
        "incorrectInput": "Entrée incorrecte",
        "playerName": "Nom",
        "playerNamePlaceholder": "Nom du player",
        "requiredPlayerName": "Le nom du player est requis",
        "requiredScreenDiagonal": "La diagonale de l'écran est requise",
        "requiredHorizontalBezel": "Le rebord/gap horizontal est requis",
        "requiredVerticalBezel": "Le rebord/gap vertical est requis",
        "playerTimezoneHint": "Sélectionner le fuseau horaire du player",
        "Progress_PIN": "PIN",
        "Progress_Name": "Nom et fuseau horaire",
        "Progress_DisplaySettings": "Paramètres d'affichage",
        "Progress_Application": "Application",
        "Progress_Arrangement": "Disposition",
        "Progress_Adjustments": "Ajustements",
        "DisplayOrientation": "Orientation de l'écran",
        "DisplayResolution": "Résolution d'écran",
        "DisplayResolutionHint": "Sélectionnez la résolution d'écran",
        "Application": "Application",
        "ApplicationSingleDisplay": "Écran unique",
        "ApplicationMirroring": "Duplication",
        "ApplicationVideowall": "Mur vidéo",
        "ApplicationAvailable": "* Disponible avec",
        "ApplicationAvailbleWithNote": "*Disponible avec",
        "screenDiagonal": "Diagonale de l'écran",
        "SelectApplication": "Sélectionner l'application",
        "SelectDisplayOrientation": "Sélectionner l'orientation de l'écran",
        "SelectNumberOfDisplays": "Sélectionner le nombre d'écrans",
        "standardScreenOnly": "Écran standard uniquement (9:16 & 16:9)",
        "OrientationAndResolution": "Les paramètres d'orientation et de résolution s'appliqueront à tous les écrans",
        "DisplaysArrangement": "Disposition de l’écran",
        "SelectDisplayArrangement": "Sélectionner la disposition de l’écran",
        "HorizontalBezel": "Rebord/gap horizontal",
        "VerticalBezel": "Rebord/gap vertical",
        "OutputResolutions": "Résolutions de sortie",
        "CannotCreateLEDTag": "Impossible de créer une résolution LED",
        "CannotCreateVideowallTag": "Impossible de créer une toile de mur vidéo",
        "UnknownError": "Erreur inconnue survenue. Veuillez réessayer ou contacter le support.",
        "InvalidAdjustmentsForm": "Il y a des erreurs de validation des entrées, veuillez remplir tous les champs correctement",
        "CanvasDimensionsError": "La largeur ou la hauteur de la toile ne sont pas générées correctement",
        "playerDeleteConfirmation": "Êtes-vous sûr de vouloir supprimer le lecteur : {playerName} ?",
        "playerDeleteWarning": "La suppression du lecteur le retirera de votre compte SpinetiX HUB et supprimera tous les paramètres associés, y compris la planification."
    },
    "planCard": {
        "getPremium": "Passer Premium",
        "bestforGettingStarted": "Idéal pour commencer",
        "discovery": "Discovery",
        "free": "Gratuit",
        "oneUser": "1 Utilisateur",
        "oneGBStorage": "1 Go de stockage",
        "nineTemplates": "9 Modèles",
        "yourPlan": "Votre plan",
        "elevateYourDigitalSignage": "Améliorez votre affichage numérique",
        "premium": "Premium",
        "premiumPlanPrice": "21 CHF",
        "playerPerMonth": "Player/Mois",
        "tenUsersAndRoles": "10 Utilisateurs et rôles des utilisateurs",
        "tenGBPlayerStorage": "10 Go/Stockage du player",
        "twelveTemplatesCustomizable": "12 modèles/personnalisables",
        "twelveApps": "12 applications dont une page web",
        "elevenApps": "11 applications",
        "assetGrouping": "Regroupement des actifs",
        "scheduleAutomation": "Automatisation des horaires",
        "priorityScheduling": "Attribution de priorités",
        "alerts": "Alertes",
        "audio": "Audio",
        "videoWallSupport": "Aide avec le mur vidéo*",
        "new": "Nouveau !",
        "withTheNew": "*Avec le nouveau"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "Erreur lors de la récupération de la facture. Veuillez réessayer.",
        "close": "fermer",
        "getPremium": "Passez Premium !",
        "companyName": "Nom de l'entreprise",
        "dialogTitle": "Mise à niveau du plan",
        "navConfirm": "Confirmer",
        "navFinish": "TERMINER",
        "navNext": "Suivant",
        "navPrev": "Retour",
        "navCancel": "Annuler",
        "VATNumber": "Numéro de TVA",
        "Overview": "Aperçu",
        "AccountOwner": "Propriétaire du compte",
        "CompanyInfo": "Informations sur l'entreprise",
        "BillingDetails": "Informations de facturation",
        "Payment": "Paiement",
        "tryAgain": "RÉESSAYEZ",
        "paymentSuccessful": "Paiement effectué",
        "welcomeToPremium": "Bienvenue en Premium !",
        "paymentFailed": "Le paiement a échoué.",
        "selectCountry": "Sélectionner le pays",
        "selectState": "Sélectionner l’État"
    },
    "licenseOrdering": {
        "yourOrders": "Vos commandes",
        "cancelOrder": "ANNULER LA COMMANDE",
        "orderNumber": "Numéro de commande",
        "orderDate": "Date de la commande",
        "comment1": "Commentaire 1",
        "comment2": "Commentaire 2",
        "close": "FERMER",
        "cancelOrderWarning": "Êtes-vous sûr de vouloir annuler cette commande ?",
        "noOrdersAvailable": "Vous n'avez pas passé de commande",
        "noRecordsFound": "Aucun résultat trouvé pour la requête \"{query}\"",
        "noRecordsFoundNote1": "Veuillez vérifier si votre recherche ne contient pas de fautes de frappe ou d'erreurs",
        "noRecordsFoundNote2": "Essayez d'utiliser une autre requête"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "L'utilisateur n'est pas autorisé à effectuer des mises à jour sur le média.",
        "hashMD5ComputationError": "Une erreur s'est produite lors du calcul du hashMD5.",
        "duplicateFileUploadErrorTitle": "Un fichier portant ce nom existe déjà",
        "multipleDuplicateFileUploadErrorTitle": "Des fichiers portant ces noms existent déjà",
        "duplicateFileUploadErrorDescription": "Un fichier nommé \"{mediaName}\" existe déjà dans votre bibliothèque.",
        "multipleDuplicateFileUploadErrorDescription": "Des fichiers nommés \"{mediaNames}\" existent déjà dans votre bibliothèque.",
        "duplicateFileUploadErrorMessage": "Examinez le(s) fichier(s) existant(s) et choisissez ce que vous souhaitez faire de votre nouvel envoi.\n{pleaseNote}: Si vous remplacez le fichier existant, rechargez la page une fois l'envoi terminé pour voir la version mise à jour.",
        "duplicateFileUploadPreviewTitle": "Fichier(s) existant(s)",
        "pleaseNote": "Veuillez noter"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "Êtes-vous sûr ? Cette méthode est réservée aux lecteurs qui ne seront pas connectés à Internet.",
        "confirmDownloadLicenseWarning": "L'utilisation de cette méthode associera immédiatement la licence au numéro de série sans délai de grâce pour les modifications."
    },
    "activation": {
        "assign": "ASSIGNER",
        "yourLicenses": "Vos licences",
        "comment": "Commentaire",
        "playerSerialNumber": "Numéro de série du player",
        "licenseCode": "Code de licence",
        "activationDate": "Date d'activation",
        "license": "Licence",
        "suspend": "SUSPENDRE",
        "restore": "RESTAURER",
        "download": "TÉLÉCHARGER",
        "licenseAvailable": "Licence disponible",
        "licenseLockedToAPlayer": "Licence liée à un joueur",
        "playerSerialNumberRequired": "Numéro de série du player - Code requis",
        "licenseCodeRequired": "Code de licence requis",
        "processing": "Traitement",
        "waitingForPlayerToConnect": "En attente de connexion du player",
        "noLicensesAvailable": "Vous n'avez pas ajouté de licences"
    },
    "resolutionCalculator": {
        "invalidPitch": "Pitch non valable",
        "invalidSize": "Taille non valable"
    },
    "legal": {
        "legal": "juridique",
        "endUserLicenseAgreement": "CONTRAT DE LICENCE UTILISATEUR FINAL",
        "generalTermsAndConditionsOfSale": "CONDITIONS GÉNÉRALES DE VENTE",
        "termsOfService": "CONDITIONS D’UTILISATION",
        "privacyPolicy": "POLITIQUE DE CONFIDENTIALITÉ",
        "cookieNotice": "AVIS RELATIF AUX COOKIES",
        "downloadPDF": "TELECHARGER LE PDF"
    },
    "accountSuspended": {
        "bannerTitle": "Votre abonnement a expiré !",
        "bannerMessage": "Si vous souhaitez renouveler votre abonnement, veuillez contacter votre revendeur."
    },
    "errors": {
        "invalid": {
            "verificationCode": "Le code de vérification fourni est invalide, veuillez réessayer.",
            "passwordReset": "Le mot de passe ne peut pas être réinitialisé.",
            "provider": "Fournisseur invalide. Veuillez réessayer.",
            "emailMismatch": "L’adresse e-mail que vous avez saisie ne correspond pas au compte vers lequel vous essayez de migrer."
        },
        "existing": {
            "accountInAnotherRegion": "L'utilisateur a déjà un compte dans une autre région",
            "userAlreadyLinked": "L’utilisateur est déjà lié à un autre fournisseur d’identité (IdP)."
        },
        "failedRefreshToken": "Vous avez été déconnecté. Veuillez vous reconnecter pour continuer.",
        "cannotMigrateAccountInAnotherRegion": "Impossible de migrer vers le SSO car votre adresse e-mail est liée à une autre région de stockage de données que le compte vers lequel vous essayez de migrer.",
        "nonSSOAuthDenied": "L'authentification via un fournisseur non-SSO n'est pas autorisée.",
        "ssoMigrationFailed": "Accès refusé : Vous ne pouvez pas passer au SSO car votre compte est déjà lié à un autre fournisseur d’identité (IdP). Veuillez contacter votre administrateur pour obtenir de l’aide.",
        "loginUnexpectedError": "La connexion a échoué en raison d’une erreur inattendue. Veuillez réessayer.",
        "unexpectedError": "Une erreur inattendue s'est produite. Veuillez recharger la page.",
        "somethingWentWrong": "Il semble que quelque chose s'est mal passé ({errorCode})",
        "somethingWentWrongDescription": "Une erreur s'est produite lors du chargement de cette page.<br><br><strong>Ce que vous pouvez faire :</strong><br>Actualisez la page et réessayez.<br>Si elle ne se charge toujours pas, veuillez contacter le support et partager l'ID de demande ci-dessous.",
        "failedToUpdateAccountInfo": "Échec de la mise à jour des informations du compte.",
        "failedToFetchLicenses": "Impossible de récupérer les licences.",
        "failedToDownloadLicense": "Impossible de télécharger la licence.",
        "failedToDownloadFile": "Impossible de télécharger le fichier.",
        "failedToFetchUserInfo": "Impossible de récupérer les informations utilisateur",
        "failedToFetchPlaces": "Impossible de récupérer les lieux",
        "fileNotSupported": "Type de fichier non pris en charge."
    },
    "regionNames": {
        "eu": "Union européenne / European Union",
        "ch": "Suisse / Switzerland",
        "us": "États-Unis / United States",
        "ca": "Canada / Canada",
        "au": "Australie / Australia",
        "hk": "Hong Kong / Hong Kong",
        "sg": "Singapour / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "Le chat n'a pas pu être chargé",
        "chatCouldNotBeLoadedDescription": "Nous n'avons pas pu charger le chat de support. Cela est généralement dû aux paramètres de confidentialité ou de cookies de votre navigateur. Pour obtenir des instructions sur l'activation du chat de support, cliquez ici : {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "Préparation de votre média…",
        "mediaUploadSuccessMessage": "Il se peut qu'il n'apparaisse pas dans la vue actuelle en raison de filtres ou d'un tri actifs.",
        "mediaViewLegacyToV2Title": "Pages médias repensées",
        "mediaViewV2ToLegacyTitle": "Vous utilisez le nouveau design !",
        "mediaViewSwitcherDescription": "Navigation plus rapide, filtres et tri.",
        "mediaDeleteConfirmation": "Êtes-vous sûr de vouloir supprimer le média \"{mediaName}\" ?",
        "multipleMediaDeleteConfirmation": "Voulez-vous vraiment supprimer les {mediaCount} éléments multimédias sélectionnés ?",
        "mediaDeleteWarning": "La suppression de ce média le supprimera également de tous les projets.",
        "multipleMediaDeleteWarning": "La suppression de ces médias les supprimera également de tous les projets qui les utilisent.",
        "mediaFileUploadInfoMessage": "Si vous ne les voyez pas dans votre vue actuelle, ils peuvent être masqués par des filtres actifs ou un tri.",
        "mediaIsReady": "Vos médias sont prêts!",
        "mediaIsReadyWithCount": "Vos médias sont prêts! ({count} sur {total})",
        "someFilesUploadError": "Certains fichiers n'ont pas pu être traités",
        "failedUploadError": "Vos fichiers n'ont pas pu être traités. Essayez de les télécharger à nouveau.",
        "failedUploadErrorTitle": "Nous n'avons pas pu traiter vos médias"
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "Êtes-vous sûr de vouloir quitter le compte [{accountName}] ?",
        "leaveAccountWarning": "En quittant ce compte, vous perdrez l'accès au compte et à tous les produits et services associés actuellement disponibles."
    },
    "led": {
        "deleteCanvasConfirmation": "Êtes-vous sûr ? Cette action supprimera cette résolution de canvas de tous les lecteurs.",
        "deleteCanvasWarning": "Tout lecteur ayant utilisé cette résolution de canvas devra être reconfiguré avant que du contenu avec la même résolution puisse y être publié à nouveau."
    },
    "popId": {
        "deletePopIdConfirmation": "Êtes-vous sûr ? Cette action supprimera cet ID PoP partout où il est utilisé."
    },
    "tag": {
        "deleteTagConfirmation": "Êtes-vous sûr ? Cette action supprimera ce tag de tous les {source}.",
        "deleteTagWarning": "Cela pourrait affecter vos autorisations utilisateur et votre planification."
    },
    "userProfile": {
        "permanent": "permanent",
        "deleteUserConfirmation": "Vous êtes sur le point de supprimer votre profil utilisateur. Cette action est {permanent} et ne peut pas être annulée.",
        "lose": "perdrez",
        "deleteUserWarning": "En continuant, vous {lose} l'accès à tous les comptes et produits associés à vos identifiants.\nÊtes-vous sûr de vouloir continuer ?"
    }
}
